import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getActionReasons, getCouponReasonOptions, getDecisionNodeAtPath } from '../../../../../../extractFromState';
import { addEdgeToDecisionTreePath } from '../../../../../../actions/searchActions';
import { AVAILABLE_FIELDS_CONFIG, DTSelectActionReasonView } from '../../DTSelectActionReasonView';
import SelectInputs from '../../Common/SelectInputs/SelectInputs';
import { getRbiExistingSupportCouponsCount } from '../../../../../../selectors/tools';

const DTSelectCouponReasonNode = () => {
  const dispatch = useDispatch();

  const couponReasonOptions = useSelector(getCouponReasonOptions);
  const actionReasons = useSelector(getActionReasons);
  const decisionNode = useSelector(getDecisionNodeAtPath);
  const rbiIssuedCouponsCount = useSelector(getRbiExistingSupportCouponsCount);

  useEffect(() => {
    if (decisionNode.maxCouponsLinit && rbiIssuedCouponsCount >= parseInt(decisionNode.maxCouponsLinit)) {
      dispatch(addEdgeToDecisionTreePath('max_coupons_limit_exceeded'));
    }
  }, [dispatch, rbiIssuedCouponsCount, decisionNode]);

  const handleNextButtonClick = () => dispatch(addEdgeToDecisionTreePath('reason_selected'));

  return (
    <DTSelectActionReasonView
      isNextButtonActive={actionReasons?.couponPrimaryReason}
      onNextButtonClick={handleNextButtonClick}
    >
      <SelectInputs
        placeholder="Select coupon reason"
        options={couponReasonOptions}
        fields={AVAILABLE_FIELDS_CONFIG.couponReason}
      />
    </DTSelectActionReasonView>
  );
};

export default DTSelectCouponReasonNode;
